import { useQuery } from "@tanstack/react-query";
import {
  fetchOrganizationBackgroundImages,
  organizationBackgroundImagesQueryKey,
} from "./imageGalleryApi";

export function useOrganizationBackgroundImages(
  organizationId: string | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: organizationBackgroundImagesQueryKey(organizationId),
    queryFn: () => fetchOrganizationBackgroundImages(organizationId!),
    enabled: Boolean(organizationId) && enabled,
  });
}
